import React, { useState } from 'react';
import { Link } from '../../Link/Link';
import { Logo } from '../../Logo/Logo';
import { Paragraph } from '../../Paragraph/Paragraph';
import { GameGraphics } from '../../GameGraphics/GameGraphics';
import { GameActions } from '../../TileActions/GameActions';
import { TilePill } from '../../TilePill/TilePill';
import type { TileProps } from '../tiles';
import { GAME_UNAVAILABLE } from '../../../helpers/tileHelper';
import { track } from '../../../helpers/tracking';

export const WinnerTile = ({
  title,
  type,
  gameGraphics,
  alias,
  prize,
  winMinutes,
  navigationUrlWithLaunchParam,
  isTableClosed,
  isUnavailable,
  className,
  onClick,
  tabIndex,
  navigationUrl
}: TileProps) => {
  const [graphicsLoading, setGraphicsLoading] = useState(true);
  const [graphicsError, setGraphicsError] = useState(false);

  const linkAriaLabel = `Start spil ${title}`;

  const graphicsDisabled = isUnavailable || (type !== 'Casino' && isTableClosed);
  const shouldRenderLogo = (graphicsError && !graphicsDisabled)  || !gameGraphics?.backgroundUrl;

  return (
    <article
      data-tracking-meta-data={JSON.stringify({
        tileType: 'Winner',
        gameTitle: title,
        prize: prize,
      })}
      onClick={onClick}
      className={`group w-full relative grid grid-cols-[0_8rem_auto] md:grid-cols-[0_9.6rem_auto] rounded-32 after:items-center is-desktop-detected:hover:bg-neutrals-white/25 p-12 pr-0 ${className}`}>

      <div onClick={track}>
        <Link
          className='absolute top-0 right-0 bottom-0 left-0 focus-visible:ring-primary rounded-32 z-20'
          href={navigationUrl}
          ariaLabel={linkAriaLabel}
          disabled={isUnavailable || !navigationUrlWithLaunchParam}
          tabIndex={tabIndex}
        />
      </div>

      <div className='relative h-full aspect-square flex size-80 md:size-96'>
        <GameGraphics
          {...gameGraphics}
          isLoading={graphicsLoading}
          imageWidth={100}
          onLoaded={() => setGraphicsLoading(false)}
          onError={() => setGraphicsError(true)}
          lazyLoad={true}
          error={graphicsError}
          disabled={graphicsDisabled}
          disableCache={type === 'Live'}
          useDarkGradient={type === 'Live' && !isUnavailable}
          useLogoAsForeground={type !== 'Live'}
          useThumbnailAsBackground={type !== 'Live'}
          className='overflow-hidden'
          rounded='rounded-24'
          backgroundStyle={type === 'Live' ? 'object-top' : ''}
        />

        {!isUnavailable && (
          <GameActions
            href={navigationUrlWithLaunchParam}
            linkAriaLabel={linkAriaLabel}
            className='z-20 m-auto
                opacity-0 transition-opacity duration-100 ease-in-out
                is-desktop-detected:group-hover:opacity-100 is-desktop-detected:group-focus-within:opacity-100 is-desktop-detected:group-focus:opacity-100'
            tabIndex={tabIndex}
            isTableClosed={isTableClosed}
          />
        )}

        {shouldRenderLogo && (
          <div className='absolute h-full w-full flex flex-col justify-center align-center'>
            <Logo className='w-24 z-10  mx-auto' />
          </div>
        )}
      </div>

      <div className='flex flex-col justify-center text-white fill-white ml-4 mr-8 flex-1'>

        {title && <TilePill
          text={title}
          background='transparent'
        />}

        <>
          <div className='flex items-center'>
            {alias && <TilePill
              text={alias}
              background='transparent'
              textSize={16}
            />}
          </div>


          {prize && (
            <TilePill
              text={prize}
              additionalInfo={winMinutes}
              background='transparent'
              textSize={16}
              textWeight='bold'
            />
          )}
        </>
      </div>

      {isUnavailable && (
        <Paragraph
          size={12}
          className='relative self-center text-center my-auto max-w-[20ch] text-white'
        >
          {GAME_UNAVAILABLE}
        </Paragraph>
      )}
    </article>
  );
};
